export default ({ subject }) => subject && subject.permissions.canUpdate;
